import { create } from 'zustand';
import api from '../services/api';

const useAuthStore = create((set, get) => ({
  user: null,
  token: localStorage.getItem('token'),
  loading: false,

  setUser: (user) => set({ user }),
  setToken: (token) => { localStorage.setItem('token', token); set({ token }); },

  login: async (email, password, isAdmin = false) => {
    set({ loading: true });
    try {
      const endpoint = isAdmin ? '/auth/superadmin/login' : '/auth/login';
      const res = await api.post(endpoint, { email, password });

      // Handle response - could be direct or wrapped
      const data = res.data || res;
      const token = data.token;
      const user  = data.user;

      if (!token) {
        set({ loading: false });
        return { success: false, message: data.message || 'Login failed - no token received' };
      }

      localStorage.setItem('token', token);
      if (data.refreshToken) localStorage.setItem('refreshToken', data.refreshToken);
      set({ user, token, loading: false });
      return { success: true, user };
    } catch (err) {
      set({ loading: false });
      const message = err.response?.data?.message || err.message || 'Login failed';
      return { success: false, message };
    }
  },

  logout: () => {
    localStorage.clear();
    set({ user: null, token: null });
  },

  fetchMe: async () => {
    try {
      const res = await api.get('/auth/me');
      const user = res.data?.user || res.data;
      if (user && user.id) {
        set({ user });
        return user;
      }
      return null;
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.clear();
        set({ user: null, token: null });
      }
      return null;
    }
  },
}));

export default useAuthStore;
